import mock from "./mock";
import "./tables/datatables";
import "./chat";

mock.onAny().passThrough();
